import styled from "styled-components";

export const FavoritePageContainer = styled.div`
  padding: 0 100px 0 100px;
`;

export const FavoriteImg= styled.img`
  width: 100%;
  height: auto;

`;  